import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  hasSelectedMileageFilterSelector,
  mileageFilterDefaultState,
  mileageFilterState,
  searchMileageTypesState,
  selectedMileageFilterLabelSelector,
  selectedMileageFilterSelector,
} from '@/states/filters/mileage.state';

export function useMileageFilter() {
  const [mileageFilterDefault, setMileageFilterDefault] = useRecoilState(
    mileageFilterDefaultState
  );

  const [mileageFilter, setMileageFilter] = useRecoilState(mileageFilterState);
  const [searchMileageTypeFilter, setSearchMileageTypeFilter] = useRecoilState(
    searchMileageTypesState
  );
  const setSelectedMileageFilter = useSetRecoilState(
    selectedMileageFilterSelector
  );
  const selectedMileageFilterLabel = useRecoilValue(
    selectedMileageFilterLabelSelector
  );
  const hasSelectedMileageFilter = useRecoilValue(
    hasSelectedMileageFilterSelector
  );

  const resetMileageFilter = () => {
    const defaultRange = { min: 0, max: 0 };

    setSelectedMileageFilter(defaultRange);
    setMileageFilter(defaultRange);
  };

  return {
    mileageFilter,
    setMileageFilter,
    setSelectedMileageFilter,
    selectedMileageFilterLabel,
    hasSelectedMileageFilter,
    mileageFilterDefault,
    setMileageFilterDefault,
    resetMileageFilter,
    searchMileageTypeFilter,
    setSearchMileageTypeFilter,
  };
}
